const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/soh/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import ECheckinForm from 'App/config/soh/eCheckin/ECheckinForm';
import Footer from 'App/config/soh/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: undefined,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.solothurnerspitaeler.ch',
        loginHelp: 'https://www.solothurnerspitaeler.ch/meinesoh',
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
        Beruf: 'Lookup/03f9144a-3abd-4943-b5fa-25a37f6d29a2/Children',
        Geschlecht: 'Lookup/839d2748-2740-4dfa-81dd-5ab54350e30b/Children',
        CHWohnort: 'Lookup/5a16fd75-6a6c-45e7-b6f9-1b0bf00d6daa/Children',
        Zivilstand: 'Lookup/da608573-65ec-4904-9f2f-48ed1196b71f/Children',
        YesNo: 'Lookup/f075869f-7886-4f4a-8a3a-5b64c8640bf0/Children',
        Beziehung: 'Lookup/6d6e31a0-587c-4ec2-8781-96bf0b49b7d3/Children',
        Behandlungsgrund: 'Lookup/05c8e075-0027-4506-86de-020011219806/Children',
        Versicherung: 'Lookup/8f63beba-35a9-44d2-8fec-8d0abf0c0bc4/Children',
        Klasse: 'Lookup/940e5ce0-c969-4b55-9bc7-8b5059ec4dd7/Children',
        ZugewiesenDurch: 'Lookup/05739798-7f8d-4236-a16e-508707ace539/Children',
        Religion: 'Lookup/4b9d857f-7ee4-43d5-bdbe-e5e68c6b4d57/Children',
        Sprache: 'Lookup/85aa5261-5ffe-4c2c-bdf9-bf0bde3e6927/Children',
        Versicherungsangabe: 'Lookup/637a0b33-487f-46aa-9ed1-cc2505924913/Children',
        Asylsuchend: 'Lookup/24126354-0f8b-4b64-9d6f-4a0ead7589dd/Children',
        Zusatzleistungen: 'Lookup/e9db298b-711e-441b-bd3f-048bf32a5b31/Children',
        überweisendeArzt: 'Lookup/e9b1e13e-5cbd-4e7c-b2c0-246402042e3b/Children',
        ZimmerBuchenAllgemein: 'Lookup/5131c31e-e964-466b-b561-23fc548bbe3d/Children',
        ZimmerBuchenHalbprivat: 'Lookup/bc0d0d8a-5f6a-4e78-a4f1-622ab32f66f3/Children',
        GeburtPacketAllgemein: 'Lookup/d063d10f-a91c-40ba-a96a-e91b5bc4351e/Children',
        GeburtPacketHalbPrivat: 'Lookup/dabd4f54-ea98-4e38-b5ee-87dc25ce8fb6/Children',
        GeburtPacketPrivat: 'Lookup/329c6a84-0944-4e47-9c75-a94aa706129e/Children',
    },
    customMatomoClientId: 3,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: textMap.videoCallDisclaimerText,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
